import { HttpClient, APIResponseType } from '../types';
import { AxiosAdapter } from './AxiosAdapter'; // or FetchAdapter

class ApiService {
  private httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  // Generic method to make GET requests
  async get<T>(url: string, params?: Record<string, any>): Promise<APIResponseType<T>> {
    return this.httpClient.get<T>(url, params);
  }

  // Generic method to make POST requests
  async post<T>(url: string, data?: any, config?: any): Promise<APIResponseType<T>> {
    return this.httpClient.post<T>(url, data, config);
  }

  // Generic method to make PUT requests
  async put<T>(url: string, data?: any, config?: any): Promise<APIResponseType<T>> {
    return this.httpClient.put<T>(url, data, config);
  }

  // Generic method to make DELETE requests
  async delete<T>(url: string, config?: any): Promise<APIResponseType<T>> {
    return this.httpClient.delete<T>(url, config);
  }
}

// Create an instance of ApiService with the desired HTTP client
const httpClient = new AxiosAdapter(); // or new FetchAdapter()
const apiService = new ApiService(httpClient);

export default apiService;